var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#105880",
    d: "M10 2a7.94 7.94 0 0 1 7.37 4.9 7.8 7.8 0 0 1 .02 6.16A8.03 8.03 0 0 1 10 18a8.15 8.15 0 0 1-5.66-2.34A8.15 8.15 0 0 1 2 10a7.95 7.95 0 0 1 4.94-7.39C7.9 2.21 8.94 2 10 2Zm2.47 13.95A6.41 6.41 0 0 0 16.43 10c0-1.16-.29-2.24-.87-3.22a6.31 6.31 0 0 0-2.34-2.34A6.4 6.4 0 0 0 3.57 10a6.32 6.32 0 0 0 3.2 5.57 6.47 6.47 0 0 0 5.7.38Zm-3.29-8.4V5.92h1.64v1.63H9.18Zm0 6.53V8.53h1.64v5.55H9.18Z"
  })));
};
export default SvgInfo;